export const isProduction = process.env.REACT_APP_RELEASE_STAGE === 'production';
